const ACTION_DENYLIST_FOR_DEVTOOLS = [
  "##BROWSER/CLICK",
  "##BROWSER/WINDOW_BLUR",
  "##BROWSER/WINDOW_FOCUS",
  "##BROWSER/WINDOW_RESIZE",
  "##BROWSER/WINDOW_LOAD",
  "##BROWSER/WINDOW_SCROLL",
  "##axios/REQUEST_SENT",
  "##axios/RESPONSE_RECEIVED",
  "##api/REQUEST_SENT",
  "##api/RESPONSE_RECEIVED",
  "##user/CLICK",
  "SHARED/LOADING_STATUS",
  "##app/VERSION_CHECK",
  "shared/toggleRequestsInProgressStatus"
];

export default ACTION_DENYLIST_FOR_DEVTOOLS;
